<div id="file-uploader">
	<label for="file">
		<input
			#f
			id="file"
			type="file"
			class="w-100"
			(change)="selectedFile = $any($event).target.files"
			[multiple]="multiple"
			[accept]="filesType"
			[disabled]="disabled" />

		<div class="p-inputgroup">
			<span class="p-inputgroup-addon">
				<i class="far fa-file"></i>
			</span>
			<span class="input-file">{{ uploadedFile ? fileNames : ('file-upload.select-file-upload' | translate) }}</span>
		</div>
	</label>
</div>
